import { BUSINESS_TYPE_MYDASHBOARD, FOLDER_NAME_FAVORITES } from "@/pages/dashboard/_config/constant";

export const handleMenuData = (menuList: Array<any>): object => {
  const dashboardList = [] as any;
  const folderList = [] as any;
  const subFolderList = [] as any;
  const showNewMenusMap = new Map();
  menuList.forEach((menu => {
    (menu?.folder_list || []).forEach((folder: any) => {
      // 屏蔽Favorites目录，该目录表示收藏的报表，并不不能添加实体报表
      const { business_type: businessType, name_en: nameEn } = folder;
      if (!(businessType === BUSINESS_TYPE_MYDASHBOARD && nameEn === FOLDER_NAME_FAVORITES)) {
        folderList.push(folder);
      }
      (folder?.dashoboard_list || []).forEach((dashboard: any) => {
        dashboard.parent_name_en = folder.name_en;
        dashboard.parent_name_cn = folder.name_cn;
        if (dashboard?.menu_type === '2') {
          // 判断菜单上是否需要展示New
          if (dashboard.new_flag) {
            const paths = showNewMenusMap.get(folder?.name_en) || new Set();
            showNewMenusMap.set(folder?.name_en, paths.add(dashboard?.path));
          }
          dashboard.folder_id = folder?.id || '';
          dashboardList.push({
            ...dashboard,
            parent_name_en: folder?.name_en,
            parent_name_cn: folder?.name_cn,
            menu_id: menu?.id || '',
          });
        } else if (dashboard?.menu_type === '3') {
          subFolderList.push(dashboard);
          dashboard?.dashoboard_list?.forEach((subDashboard: any) => {
            // 判断子目录是否需要展示New
            if (subDashboard.new_flag) {
              const paths = showNewMenusMap.get(dashboard?.name_en) || new Set();
              const folderPaths = showNewMenusMap.get(folder?.name_en) || new Set();
              showNewMenusMap.set(folder?.name_en, folderPaths.add(subDashboard?.path));
              showNewMenusMap.set(dashboard?.name_en, paths.add(subDashboard?.path));
            }
            subDashboard.parent_name_en = dashboard?.name_en;
            subDashboard.parent_name_cn = dashboard.name_cn;
            subDashboard.folder_id = folder?.id || '';
            dashboardList.push({
              ...subDashboard,
              parent_name_en: dashboard?.name_en,
              parent_name_cn: dashboard?.name_cn,
              menu_id: menu?.id || '',
            });
          });
        }

        // 判断二级目录是否默认展开
        if (!folder.isDefaultOpen) {
          folder.isDefaultOpen = menu?.business_type === "game" && (dashboard?.path?.includes("/overview/") || dashboard?.path?.includes("/realtime/"));
        }
      });
    });
  }));
  return {
    menuList,
    folderList,
    subFolderList,
    dashboardList,
    showNewMenusMap
  };
};
